import React from 'react';
import { VendorCell } from '../lists/invoiceList';
import { CopyableCell } from '../../components/Common/Components/CopyableCell';

// New UI, dashboard gadgets (docs/ui_redesign/17-dashboard-insights-vendormap-as-built.md): the vendor column shows the
// name in bold with the code under it, as in the Invoices list. Every other column is Classic's, unchanged.

// The module dashboards: /Media/Dashboard/, the module root (/Media/), and the app root, which also renders a Dashboard.
export const isDashboardPage = (path = typeof window !== 'undefined' ? window.location.pathname : '') =>
	/^\/((media|production|broadcast)(\/dashboard)?\/?)?$/i.test(path);

function VendorNameCell({ name, code }) {
	const showCode = code && String(code) !== String(name);
	return (
		<CopyableCell value={name || ''} tooltipTitle={showCode ? `${name} (${code})` : name || ''} style={{ display: 'block', minWidth: 0, width: '100%' }}>
			<span className="apw2-two"><b>{name}</b>{showCode ? <small>{code}</small> : null}</span>
		</CopyableCell>
	);
}

// columns: a gadget's column list. A row without a vendor keeps Classic's cell (the scanned vendor identifier, in orange).
export function dashboardColumns(columns) {
	if (!Array.isArray(columns)) return columns;
	return columns.map(c => {
		if (!c || (c.field !== 'vendorNameCode' && c.field !== 'vendorName')) return c;
		const classic = c.renderCell;
		return {
			...c,
			minWidth: Math.max(c.minWidth || 0, 160),
			renderCell: params => {
				const row = (params && params.row) || {};
				if (c.field === 'vendorNameCode') {
					return row.vendorNameCode ? <VendorCell value={row.vendorNameCode} /> : classic ? classic(params) : '';
				}
				const name = row.vendorName || row.vendorCode; // Classic's displayVendorName
				return name ? <VendorNameCell name={name} code={row.vendorName ? row.vendorCode : ''} /> : classic ? classic(params) : '';
			}
		};
	});
}
